export class ReportPeriodApiPaths {
    constructor(private readonly api: string) {}

    getRecurringReportPeriods = (siteId: string) => `${this.api}/recurring/${siteId}`;
    getOneOffReportPeriods = (siteId: string) => `${this.api}/oneoff/${siteId}`;
}
